import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function CreateDateIcon() {
  return (
    <SvgIcon
      viewBox="-2 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.09827 2L3.09827 1C3.09827 0.447715 3.54598 0 4.09827 0C4.65055 0 5.09827 0.447715 5.09827 1V2H11.0983V1C11.0983 0.447715 11.546 0 12.0983 0C12.6506 0 13.0983 0.447715 13.0983 1V2H14.0983C15.2028 2 16.0983 2.89543 16.0983 4V7.06189C15.7707 7.02104 15.4369 7 15.0983 7C14.7596 7 14.4259 7.02104 14.0983 7.06189V7H2.09827V16H7.16016C7.24728 16.6986 7.42448 17.3693 7.67978 18H2.09827C0.993698 18 0.0982666 17.1046 0.0982666 16V4C0.0982666 2.89543 0.993697 2 2.09827 2H3.09827Z"
        fill="currentColor"
      />
      <path
        d="M14.0935 21.463V17.6458L11.3943 20.345L9.98007 18.9308L12.6793 16.2316H8.86194V14.2316H12.6794L9.98007 11.5323L11.3943 10.118L14.0935 12.8173V9H16.0935V12.8173L18.7927 10.1181L20.207 11.5323L17.5077 14.2316H21.3249V16.2316H17.5078L20.207 18.9307L18.7927 20.3449L16.0935 17.6457V21.463H14.0935Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
